/* NexTap scroll scenes. Vanilla JS, no dependencies.
   Each .scn section pins its stage; progress p (0→1) is smoothed and drives every transform. */
(function () {
  var clamp = function (v, a, b) { return Math.min(b === undefined ? 1 : b, Math.max(a || 0, v)); };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var E = {
    io: function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; },
    out: function (t) { return 1 - Math.pow(1 - t, 3); },
    in: function (t) { return t * t * t; },
    back: function (t) { var c = 1.5; return t <= 0 ? 0 : 1 + (c + 1) * Math.pow(t - 1, 3) + c * Math.pow(t - 1, 2); }
  };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nf = new Intl.NumberFormat('tr-TR');

  function Scene(el, api) {
    var self = this;
    this.el = el; this.pin = el.querySelector('.scn__pin');
    this.cur = 0; this.tgt = 0; this.active = false; this.api = api;
    this.caps = [].slice.call(el.querySelectorAll('[data-cap]')).map(function (c) {
      return { el: c, a: +c.dataset.a, b: +(c.dataset.b || 2), cta: c.querySelector('.scn-cap__cta') };
    });
    this.rail = el.querySelector('.scn__rail');
    this.hint = el.querySelector('.scn__hint');
    this.measure = function () { self.w = self.pin.clientWidth; self.h = self.pin.clientHeight; api.measure(self); };
    this.measure();
    addEventListener('resize', this.measure);
    new IntersectionObserver(function (en) {
      self.active = en[0].isIntersecting;
      if (self.active) requestAnimationFrame(self.tick);
    }, { rootMargin: '100px' }).observe(el);
    this.tick = function (t) {
      if (!self.active) return;
      var r = el.getBoundingClientRect();
      self.tgt = el.dataset.force ? +el.dataset.force : clamp(-r.top / Math.max(1, r.height - self.h));
      self.cur += (self.tgt - self.cur) * .12;
      if (Math.abs(self.tgt - self.cur) < .0004) self.cur = self.tgt;
      self.frame(self.cur, reduce ? 0 : t);
      requestAnimationFrame(self.tick);
    };
  }
  Scene.prototype.frame = function (p, t) {
    this.caps.forEach(function (c) {
      var on = p >= c.a - .005 && p <= c.b;
      c.el.classList.toggle('on', on);
      if (!on) return;
      c.el.style.setProperty('--k', (E.out(seg(p, c.a, c.a + .08)) * 122).toFixed(1));
      c.el.style.setProperty('--x', seg(p, c.b - .04, c.b).toFixed(3));
      if (c.cta) c.cta.style.setProperty('--b', E.io(seg(p, c.a + .05, c.a + .12)).toFixed(3));
    });
    if (this.rail) this.rail.style.setProperty('--p', p.toFixed(4));
    this.pin.style.setProperty('--end', seg(p, .9, 1).toFixed(3));
    if (this.hint) this.hint.style.setProperty('--h', seg(p, .01, .05).toFixed(3));
    this.api.frame(this, p, t);
  };
  var tf = function (el, s) { el.style.transform = 'translate(-50%,-50%) ' + s; };

  /* ---------------- BIREYSEL ---------------- */
  var TAP = {
    measure: function (s) {
      var el = s.el;
      s.group = el.querySelector('.scn__group');
      s.card = el.querySelector('.tap-card');
      s.phone = el.querySelector('.tap-phone');
      s.prof = el.querySelector('.tap-phone__profile');
      s.rings = [].slice.call(el.querySelectorAll('.tap-ring'));
      s.spark = el.querySelector('.tap-spark');
      s.orbs = [].slice.call(el.querySelectorAll('.orb'));
      s.paths = [].slice.call(el.querySelectorAll('.orb-path'));
      s.cw = Math.min(420, s.w * .62, s.h * .5); s.ch = s.cw / 1.586;
      s.pw = Math.min(230, s.w * .34, s.h * .36); s.ph = s.pw * 19.5 / 9;
      s.ow = Math.max(48, Math.min(78, s.w * .055));
      s.R = Math.min(s.w * .42, s.cw * 1.25);
      s.pin.style.setProperty('--cw', s.cw + 'px');
      s.pin.style.setProperty('--pw', s.pw + 'px');
      s.pin.style.setProperty('--ow', s.ow + 'px');
    },
    frame: function (s, p, t) {
      var K = .31, TAP_AT = .44;
      var f = E.io(seg(p, .8, .95));
      s.group.style.transform = 'translateY(' + (-f * s.h * .12) + 'px) scale(' + (1 - f * .3) + ')';
      s.pin.style.setProperty('--bgA', (.08 + seg(p, .42, .5) * .12).toFixed(3));

      // card
      var hit = clamp(1 - Math.abs(p - (TAP_AT + .01)) / .035);
      var glow = Math.max(hit, seg(p, TAP_AT, .5) * .35);
      var settle = 1 - E.out(seg(p, 0, .3));
      var ry = Math.sin(t / 2300) * 7 - settle * 22;
      var rx = 8 + Math.cos(t / 1900) * 4 + settle * 8;
      var fy = Math.sin(t / 1400) * 6;
      tf(s.card, 'translateY(' + fy + 'px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(' + (1 - hit * .035) + ')');
      s.card.style.setProperty('--hit', glow.toFixed(3));
      s.card.style.setProperty('--sh', (20 + p * 120 + Math.sin(t / 3000) * 10).toFixed(1));

      // phone: descend → contact → leave
      var a = seg(p, .12, TAP_AT), x2 = E.in(seg(p, .5, .64));
      var st = [s.cw * .8, -s.h * .5 - s.ph * .7, -28, 40];
      var ct = [s.cw * .24, -s.ch * .5 - s.ph * .5 + s.ph * .15, -12, 16];
      var en = [s.cw * 1.1, -s.h * .5 - s.ph * .9, -34, 40];
      var ea = E.io(a), P = a < 1 ? [0, 1, 2, 3].map(function (i) { return lerp(st[i], ct[i], ea); })
        : [0, 1, 2, 3].map(function (i) { return lerp(ct[i], en[i], x2); });
      var bob = a < 1 ? Math.sin(t / 900) * 4 * (1 - ea) : 0;
      s.phone.style.visibility = p > .66 ? 'hidden' : 'visible';
      tf(s.phone, 'translate3d(' + P[0] + 'px,' + (P[1] + bob) + 'px,0) rotateZ(' + P[2] + 'deg) rotateX(' + P[3] + 'deg)');
      s.prof.style.setProperty('--rev', (E.out(seg(p, TAP_AT - .005, .52)) * 180).toFixed(1) + '%');

      // contact spark at phone base
      var sp = clamp(1 - Math.abs(p - (TAP_AT + .005)) / .025);
      s.spark.style.opacity = sp;
      tf(s.spark, 'translate(' + (ct[0] + s.pw * .05) + 'px,' + (-s.ch * .45) + 'px) scale(' + (1 + sp * 5) + ')');

      // ripples in orbit plane
      s.rings.forEach(function (r, i) {
        var q = seg(p, TAP_AT + i * .035, TAP_AT + .24 + i * .035);
        r.style.opacity = q > 0 && q < 1 ? Math.pow(1 - q, 1.3) : 0;
        tf(r, 'rotateX(72deg) scale(' + lerp(.25, 3.6, E.out(q)) + ')');
      });

      // orbit
      var o = E.back(seg(p, .48, .68)), R = s.R * o;
      var oa = seg(p, .48, .56);
      s.paths.forEach(function (el, i) {
        var rr = R * (i < 2 ? 1 : 1.2);
        el.style.width = rr * 2 + 'px'; el.style.height = rr * 2 * K + 'px';
        el.style.setProperty('--oa', oa);
        tf(el, '');
      });
      var base = t * .00022 + p * 5.5, n = s.orbs.length;
      s.orbs.forEach(function (el, i) {
        var th = base + i * Math.PI * 2 / n, z = Math.sin(th);
        var ai = E.back(seg(p, .49 + i * .022, .6 + i * .022));
        var sc = (.7 + .3 * (z + 1) / 2) * ai;
        el.style.zIndex = z > 0 ? 32 : 3;
        el.style.opacity = ai > 0 ? .5 + .5 * (z + 1) / 2 : 0;
        tf(el, 'translate(' + Math.cos(th) * R + 'px,' + z * R * K + 'px) scale(' + Math.max(0, sc) + ')');
      });
    }
  };

  /* ---------------- KURUMSAL ---------------- */
  var TEAM = {
    measure: function (s) {
      var el = s.el;
      s.group = el.querySelector('.scn__group');
      s.all = [].slice.call(el.querySelectorAll('.tcard'));
      s.dash = el.querySelector('.dash');
      s.bars = [].slice.call(el.querySelectorAll('.dash__chart i'));
      s.nums = [].slice.call(el.querySelectorAll('[data-count]'));
      s.rows = [].slice.call(el.querySelectorAll('.dash__row'));
      s.svg = el.querySelector('.team-lines');
      var mobile = s.w < 760;
      s.cards = s.all.slice(0, mobile ? 9 : 12);
      s.all.forEach(function (c, i) { c.style.display = i < s.cards.length ? '' : 'none'; });
      var N = s.cards.length;
      s.tw = mobile ? Math.max(84, s.w * .24) : Math.max(120, Math.min(190, s.w * .12));
      s.heroW = Math.min(560, s.w * .8, s.h * .95);
      s.dw = mobile ? s.w * .9 : Math.min(860, s.w * .56);
      s.pin.style.setProperty('--tw', s.heroW + 'px');
      s.pin.style.setProperty('--dw', s.dw + 'px');
      // perimeter slots, ordered left-bottom → over the top → right-bottom
      var top = mobile ? 3 : 6, side = (N - top) / 2, slots = [];
      var sx = s.w * .5 - s.tw * .5 - s.w * (mobile ? .02 : .045);
      var span = Math.min(s.w - s.tw * 2.6, top * s.tw * 1.28);
      var ty = -s.h * (mobile ? .33 : .31);
      var sideY = mobile ? [.14, -.04, -.2] : [.25, .05, -.13];
      for (var i = 0; i < side; i++) slots.push([-sx, s.h * sideY[i]]);
      for (i = 0; i < top; i++) slots.push([lerp(-span / 2, span / 2, top === 1 ? .5 : i / (top - 1)), ty]);
      for (i = side - 1; i >= 0; i--) slots.push([sx, s.h * sideY[i]]);
      s.slots = slots;
      s.dy = -s.h * .02;
      if (s.svg) {
        s.svg.setAttribute('viewBox', (-s.w / 2) + ' ' + (-s.h / 2) + ' ' + s.w + ' ' + s.h);
        s.lines = [].slice.call(s.svg.querySelectorAll('line'));
        s.dots = [].slice.call(s.svg.querySelectorAll('circle'));
      }
    },
    frame: function (s, p, t) {
      var N = s.cards.length, W = s.tw;
      var f = E.io(seg(p, .8, .95));
      s.group.style.transform = 'translateY(' + (-f * s.h * .03) + 'px) scale(' + (1 - f * .2) + ')';

      var q0 = E.io(seg(p, 0, .14));
      var q1 = seg(p, .14, .36);
      var q2 = seg(p, .38, .7);
      var sStack = lerp(s.heroW / W, s.heroW * .56 / W, q0);
      var sFan = s.heroW * .42 / W;
      var Rf = s.h * .7;

      s.cards.forEach(function (c, i) {
        var u = N === 1 ? .5 : i / (N - 1);
        // stack (card 0 on top, edges revealed as it shrinks)
        var stx = -i * .6 * q0, sty = -i * 2.2 * q0;
        // fan: hand of cards on a wide arc
        var ang = lerp(-38, 38, u) * Math.PI / 180;
        var fx = Math.sin(ang) * Rf, fy = (1 - Math.cos(ang)) * Rf - s.h * .04;
        var fr = ang * 180 / Math.PI;
        var k1 = E.io(clamp(q1 * 1.35 - Math.abs(u - .5) * .7));
        var x = lerp(stx, fx, k1), y = lerp(sty, fy, k1), rz = lerp(0, fr, k1), sc = lerp(sStack, sFan, k1), rx = 0;
        // grid
        var sl = s.slots[i], k2 = E.io(clamp(q2 * 1.4 - u * .4));
        if (k2 > 0) {
          var fl = Math.sin(Math.PI * k2);
          x = lerp(x, sl[0], k2); y = lerp(y, sl[1], k2) - fl * s.h * .05;
          rz = lerp(rz, 0, k2); sc = lerp(sc, 1, k2) + fl * .14; rx = fl * 28;
          y += Math.sin(t / 1500 + i) * 4 * k2;
        }
        var ry = k2 * (-sl[0] / s.w) * 22;
        c.style.zIndex = N - i + 10;
        tf(c, 'translate3d(' + x + 'px,' + y + 'px,0) rotateZ(' + rz + 'deg) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(' + (sc * W / s.heroW) + ')');
        var lq = E.out(seg(p, .6 + i * .008, .72 + i * .008));
        c.style.setProperty('--sync', lq.toFixed(3));
        if (s.lines && s.lines[i]) {
          var L = s.lines[i], D = s.dots[i];
          var tx = sl[0] * .18, ty = s.dy + sl[1] * .12;
          var ex = lerp(sl[0], tx, lq), ey = lerp(sl[1], ty, lq);
          L.setAttribute('x1', sl[0]); L.setAttribute('y1', sl[1]);
          L.setAttribute('x2', ex); L.setAttribute('y2', ey);
          L.style.opacity = k2 >= 1 ? 1 : 0;
          var pulse = ((t / 1600 + i * .13) % 1);
          D.setAttribute('cx', lerp(sl[0], tx, pulse)); D.setAttribute('cy', lerp(sl[1], ty, pulse));
          D.style.opacity = lq >= 1 ? Math.sin(pulse * Math.PI) : 0;
        }
      });
      if (s.lines) for (var j = N; j < s.lines.length; j++) { s.lines[j].style.opacity = 0; s.dots[j].style.opacity = 0; }

      // glass panel: rises from depth, isometric, drawn in by a scan line
      var d = E.out(seg(p, .3, .7));
      var scan = E.io(seg(p, .34, .58));
      var fb = Math.sin(t / 1800) * 8 * d;
      var rxD = lerp(lerp(66, 42, d), 16, f), rzD = lerp(lerp(-42, -22, d), -6, f);
      tf(s.dash, 'translate3d(0,' + (lerp(s.h * .3, s.dy, d) + fb) + 'px,' + lerp(-900, 0, d) + 'px) rotateX(' + rxD + 'deg) rotateZ(' + (rzD + Math.sin(t / 2600) * .8) + 'deg)');
      s.dash.style.setProperty('--scan', scan.toFixed(3));
      s.dash.style.visibility = p < .3 ? 'hidden' : 'visible';
      s.bars.forEach(function (b, i) { b.style.setProperty('--g', E.back(seg(p, .52 + i * .012, .64 + i * .012)).toFixed(3)); });
      var cq = E.out(seg(p, .5, .76));
      s.nums.forEach(function (n) { n.textContent = nf.format(Math.round(+n.dataset.count * cq)); });
      s.rows.forEach(function (r, i) { r.classList.toggle('is-on', p > .62 + i * .03); });
    }
  };

  function boot() {
    [].slice.call(document.querySelectorAll('.scn[data-scene]')).forEach(function (el) {
      if (el.__scn) return;
      el.__scn = new Scene(el, el.dataset.scene === 'team' ? TEAM : TAP);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
